module.exports = __webpack_public_path__ + "static/media/insta.76c6cf52.png";